<template>
  <div>
    <v-list>
      <template
        v-for="(
          {
            id,
            fechaInicio,
            idContratoProgramaObra,
            fechaTermino,
            plazo,
            monto,
          },
          index
        ) in listado"
      >
        <v-list-item :key="id" link>
          <v-list-item-action>
            <v-chip>
              {{ index + 1 }}
            </v-chip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <span class="font-weight-bold">
                <!-- {{ new Date(`${fechaInicio} 00:00:0`).toLocaleDateString() }} -->
                {{ $moment(fechaInicio).format('D/M/YYYY') }}
                -
                <!-- {{ new Date(`${fechaTermino} 00:00:0`).toLocaleDateString() }} -->
                {{ $moment(fechaTermino).format('D/M/YYYY') }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>
              <span>Plazo</span>
              {{ plazo }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-row
              align="center"
              justify="space-between">
              <v-col
                v-if="!soloLectura"
                cols="auto">
                <v-tooltip v-if="(index + 1 == listado.length) && mixValidaScopesActions(3)" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        borrar({
                          id,
                          idContratoProgramaObra,
                          fechaInicio,
                          fechaTermino,
                          plazo,
                          monto,
                        })">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar</span>
                </v-tooltip>
              </v-col>
              <v-col
                cols="auto">
                <span class="success--text font-weight-medium">
                  {{ monto | currency }}
                </span>
              </v-col>
            </v-row>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="index + 1 !== listado.length" :key="`divider-${id}`">
        </v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
// import Opciones from './Opciones.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoPrograma',
  props: {
    programa: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  // components: {
  //   Opciones,
  // },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    borrar(programaContrato) {
      eventBus.$emit('eliminar-contrato-programa', programaContrato);
    },
  },
  computed: {
    listado() {
      if (!this.programa) return [];
      return this.programa
        .slice()
        .sort(
          (a, b) => new Date(`${a.fechaTermino} 00:00:0`)
            - new Date(`${b.fechaTermino} 00:00:0`),
        );
    },
  },
};
</script>

<style lang="scss">
</style>
